module.exports = __webpack_public_path__ + "static/media/woman-typing-writing-windows.e282b9af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/app2soft/images/004_mi/woman-typing-writing-windows.jpg
// module id = 772
// module chunks = 0